/**
 * Normalizes a phone number to a canonical `+<countrycode><digits>` form so
 * that Israeli local format, "00"-prefixed international format, and
 * already-E.164 numbers all converge on the same identity_index key.
 *
 * This is intentionally a light normalizer, not a full E.164 validator —
 * numbers this can't confidently classify get a best-effort "+" prefix
 * rather than being rejected, since rejection here would silently drop a
 * contact field. Validation of *whether* a phone is well-formed happens at
 * the Intake API schema layer (7-32 chars), not here.
 */
export function normalizePhone(raw) {
    const leadingPlus = raw.trim().startsWith("+");
    const digits = raw.replace(/[^\d]/g, "");
    if (leadingPlus) {
        return `+${digits}`;
    }
    if (digits.startsWith("00")) {
        return `+${digits.slice(2)}`;
    }
    if (digits.startsWith("0")) {
        // Israeli local format: 0XX-XXXXXXX -> +972XXXXXXXXX
        return `+972${digits.slice(1)}`;
    }
    if (digits.startsWith("972")) {
        return `+${digits}`;
    }
    return `+${digits}`;
}
//# sourceMappingURL=phone.js.map